import { useEffect, useState } from "react";
import { Eye, Flag, CheckCheck } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { formatApiError } from "../../lib/AuthContext";
import { ACCENT } from "./ptShared";

const STATE_LABELS = { new: "NIEUW", seen: "BEKEKEN", follow_up: "OPVOLGEN", done: "AFGEROND" };
const STATE_COLORS = { new: "#D4A93A", seen: "#60A5FA", follow_up: "#F97316", done: "#4ADE80" };

/* PT Feedback-inbox — klantfeedback markeren als Bekeken / Opvolgen / Afgerond (spec #9) */
export default function AdminPTFeedback() {
  const [items, setItems] = useState(null);
  const [noteFor, setNoteFor] = useState(null);
  const [note, setNote] = useState("");
  const load = () => api.get("/pt/admin/feedback").then(({ data }) => setItems(data.items)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const setState = async (b, state, followUpNote = "") => {
    try {
      await api.patch(`/pt/admin/feedback/${b.id}`, { state, follow_up_note: followUpNote });
      toast.success(state === "follow_up" ? "Gemarkeerd als aandachtspunt voor de volgende sessie" : `Gemarkeerd als ${STATE_LABELS[state].toLowerCase()}`);
      setNoteFor(null); setNote("");
      load();
    } catch (err) { toast.error(formatApiError(err?.response?.data?.detail) || "Mislukt"); }
  };

  return (
    <div data-testid="pt-feedback-inbox">
      <div className="chip text-[#A3A3A3] mb-4">— KLANTFEEDBACK</div>
      {items === null ? <div className="chip text-[#A3A3A3]">Laden…</div>
        : items.length === 0 ? <div className="border border-[#F5F3F0]/15 p-8 text-center chip text-[#4A4A4A]" data-testid="pt-feedback-empty">Nog geen klantfeedback ontvangen.</div>
        : <div className="space-y-3">{items.map((b) => {
            const cf = b.client_feedback;
            const st = cf.state || "new";
            return (
              <div key={b.id} className="border border-[#F5F3F0]/15 p-5" data-testid={`pt-feedback-${b.id}`}>
                <div className="flex flex-wrap items-center gap-3 mb-2">
                  <span className="font-display uppercase text-lg">{b.first_name} {b.last_name}</span>
                  <span className="chip text-[#A3A3A3]">{b.date} · {b.time}</span>
                  <span className="chip" style={{ color: ACCENT }} data-testid={`pt-feedback-rating-${b.id}`}>{cf.rating ? "★".repeat(cf.rating) : "geen score"}</span>
                  <span className="chip px-2 py-0.5 border" style={{ color: STATE_COLORS[st], borderColor: `${STATE_COLORS[st]}55` }}>{STATE_LABELS[st]}</span>
                  <span className="chip text-[#4A4A4A] ml-auto">{(cf.submitted_at || "").slice(0, 10)}</span>
                </div>
                {(cf.tags || []).length > 0 && <div className="chip text-[#A3A3A3] mb-1">{cf.tags.join(" · ")}</div>}
                {cf.comment && <p className="text-sm text-[#DDD6CB] mb-3" data-testid={`pt-feedback-comment-${b.id}`}>"{cf.comment}"</p>}
                <div className="flex flex-wrap gap-2">
                  {st !== "seen" && <button onClick={() => setState(b, "seen")} className="chip px-3 py-2 border border-[#60A5FA]/50 text-[#60A5FA] inline-flex items-center gap-1.5" data-testid={`pt-feedback-seen-${b.id}`}><Eye size={12}/> Bekeken</button>}
                  {st !== "follow_up" && <button onClick={() => setNoteFor(noteFor === b.id ? null : b.id)} className="chip px-3 py-2 border border-[#F97316]/50 text-[#F97316] inline-flex items-center gap-1.5" data-testid={`pt-feedback-follow-${b.id}`}><Flag size={12}/> Opvolgen</button>}
                  {st !== "done" && <button onClick={() => setState(b, "done")} className="chip px-3 py-2 border border-[#4ADE80]/50 text-[#4ADE80] inline-flex items-center gap-1.5" data-testid={`pt-feedback-done-${b.id}`}><CheckCheck size={12}/> Afgerond</button>}
                </div>
                {noteFor === b.id && (
                  <div className="flex gap-2 mt-3">
                    <input value={note} onChange={(e) => setNote(e.target.value)} placeholder={cf.comment || "Aandachtspunt voor volgende sessie…"} className="editorial-input dark flex-1" data-testid={`pt-feedback-note-${b.id}`} />
                    <button onClick={() => setState(b, "follow_up", note)} className="chip px-4 py-2" style={{ background: "#F97316", color: "#0A0A0A" }} data-testid={`pt-feedback-follow-save-${b.id}`}>Opslaan</button>
                  </div>
                )}
              </div>
            );
          })}</div>}
    </div>
  );
}
